import "core-js/modules/es6.regexp.split";
import _slicedToArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import coordinate from "@/util/coordinate-conversion";
var apiKey = 'd03b11c7f912468dab53b3eebeee8277';
export default {
  GetHeFengForcast: function () {
    var _GetHeFengForcast = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(latlng) {
      var _latlng$split, _latlng$split2, beforelng, beforelat, _coordinate$wgs84togc, _coordinate$wgs84togc2, lng, lat, res;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _latlng$split = latlng.split(','), _latlng$split2 = _slicedToArray(_latlng$split, 2), beforelng = _latlng$split2[0], beforelat = _latlng$split2[1];
              _coordinate$wgs84togc = coordinate.wgs84togcj02(parseFloat(beforelng), parseFloat(beforelat)), _coordinate$wgs84togc2 = _slicedToArray(_coordinate$wgs84togc, 2), lng = _coordinate$wgs84togc2[0], lat = _coordinate$wgs84togc2[1];
              res = axios({
                url: "https://dmpapi.istrongcloud.com/hefeng/v7/minutely/5m",
                params: {
                  location: "".concat(lng, ",").concat(lat),
                  apikey: apiKey
                }
              });
              return _context.abrupt("return", res);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function GetHeFengForcast(_x) {
      return _GetHeFengForcast.apply(this, arguments);
    }

    return GetHeFengForcast;
  }(),
  GetCaiyunRealtime: function () {
    var _GetCaiyunRealtime = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(latlng) {
      var _latlng$split3, _latlng$split4, beforelng, beforelat, _coordinate$wgs84togc3, _coordinate$wgs84togc4, lng, lat, res;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _latlng$split3 = latlng.split(','), _latlng$split4 = _slicedToArray(_latlng$split3, 2), beforelng = _latlng$split4[0], beforelat = _latlng$split4[1];
              _coordinate$wgs84togc3 = coordinate.wgs84togcj02(parseFloat(beforelng), parseFloat(beforelat)), _coordinate$wgs84togc4 = _slicedToArray(_coordinate$wgs84togc3, 2), lng = _coordinate$wgs84togc4[0], lat = _coordinate$wgs84togc4[1];
              res = axios({
                url: "https://dmpapi.istrongcloud.com/hefeng/v7/weather/now",
                params: {
                  location: "".concat(lng, ",").concat(lat),
                  apikey: apiKey
                }
              });
              return _context2.abrupt("return", res);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function GetCaiyunRealtime(_x2) {
      return _GetCaiyunRealtime.apply(this, arguments);
    }

    return GetCaiyunRealtime;
  }(),
  GetHeFengForcastData: function () {
    var _GetHeFengForcastData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(latlng) {
      var _latlng$split5, _latlng$split6, beforelng, beforelat, _coordinate$wgs84togc5, _coordinate$wgs84togc6, lng, lat, res;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _latlng$split5 = latlng.split(','), _latlng$split6 = _slicedToArray(_latlng$split5, 2), beforelng = _latlng$split6[0], beforelat = _latlng$split6[1];
              _coordinate$wgs84togc5 = coordinate.wgs84togcj02(parseFloat(beforelng), parseFloat(beforelat)), _coordinate$wgs84togc6 = _slicedToArray(_coordinate$wgs84togc5, 2), lng = _coordinate$wgs84togc6[0], lat = _coordinate$wgs84togc6[1];
              res = axios({
                url: "https://dmpapi.istrongcloud.com/hefeng/v7/weather/7d",
                params: {
                  location: "".concat(lng, ",").concat(lat),
                  apikey: apiKey
                }
              });
              return _context3.abrupt("return", res);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function GetHeFengForcastData(_x3) {
      return _GetHeFengForcastData.apply(this, arguments);
    }

    return GetHeFengForcastData;
  }()
};